import React, { Component, useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import {
  Container, Row, Col, Card, CardBody, Button, Badge,
  Offcanvas, OffcanvasHeader, OffcanvasBody, FormGroup,
  Label, Input, Form, FormFeedback, Alert
} from 'reactstrap';
import { getAuthCustomer, getAuthUsers, updateAuthUser, updateAuthUserPassword } from "store/actions";
import { UPDATE_AUTH_USER_SUCCESS } from "store/auth/login/actionTypes";

const UserDashboard = () => {
  const dispatch = useDispatch();

  const [userProfile, setUserProfile] = useState({})
  const [isOpen, setIsOpen] = useState(false);
  const [successMsg, setSuccessMsg] = useState(""); // ✅ success message state


  const toggle = () => setIsOpen(!isOpen);

  const { auth,lastAction } = useSelector(state => ({
    auth: state.Login.auth,
    lastAction: state.Login.lastAction, // ✅ we’ll track last redux action

  }))

  const [isPasswordOpen, setIsPasswordOpen] = useState(false);
const togglePassword = () => setIsPasswordOpen(!isPasswordOpen);

const [passwordData, setPasswordData] = useState({
  currentPassword: "",
  newPassword: "",
  confirmPassword: ""
});
const [passwordErrors, setPasswordErrors] = useState({});


  // useEffect(() => {
  //   const {user} = JSON.parse(localStorage.getItem("authUser"))
  //   setUserProfile(user);
  // },[])

    useEffect(() => {
      console.log("lastAction changed:", lastAction); // Debugging line
    if (lastAction === UPDATE_AUTH_USER_SUCCESS) {
      setIsOpen(false); // close offcanvas
      setSuccessMsg("Profile updated successfully!");
      setTimeout(() => setSuccessMsg(""), 5000); // hide after 3s
    }
  }, [lastAction]);

  useEffect(() => {
    const { user } = JSON.parse(localStorage.getItem("authUser") || "{}");
    console.log("User from localStorage 2:", auth); // Debugging lines
    if (auth?.data) {
      // console.log("Auth data exists:", auth);
      // Use the data function to ensure no null values
      const safeData = data(auth);
      setUserProfile(safeData);
      setFormData(safeData);
    } else {
      dispatch(getAuthCustomer(user?._id));
    }
  }, [auth, dispatch]);

  const menuItems = [
    {
      category: 'Orders & Quotes',
      items: [
        { icon: '📊', title: 'Place Quote', color: 'primary', description: 'Create new quotes', link: "create-quote" },
        { icon: '📋', title: 'Quote Record', color: 'info', description: 'View quote history', link: "view-quotes" },
        { icon: '🌍', title: 'Place Order', color: 'success', description: 'New digitizing orders', link: "create-order" },
        { icon: '⏺️', title: 'Orders Record', color: 'warning', description: 'Order tracking', link: "view-orders" }
      ]
    },
    {
      category: 'Vector Services',
      items: [
        { icon: '🎨', title: 'Place Vector', color: 'danger', description: 'Create vector orders', link: "create-vector" },
        { icon: '📄', title: 'Vector Record', color: 'secondary', description: 'Vector history', link: "view-vectors" },
        { icon: '🧾', title: 'Generate Invoice', color: 'dark', description: 'Generate invoices', link: "generate-invoice" },
        { icon: '📊', title: 'Invoice History', color: 'light', description: 'View all invoices', link: "invoice-history" }
      ]
    },
    // {
    //   category: 'Account & Support',
    //   items: [
    //     { icon: '💳', title: 'Credit Card Info', color: 'primary', description: 'Payment methods' },
    //     { icon: '👤', title: 'My Profile', color: 'info', description: 'Account settings' },
    //     { icon: '📞', title: 'Contact Us', color: 'success', description: 'Get support' },
    //     { icon: '❓', title: 'Help', color: 'warning', description: 'Help center' }
    //   ]
    // }
  ];

  const handleMenuClick = (title) => {
    console.log(`Clicked on ${title}`);
  };

  // Initialize form state with customer data
  const [formData, setFormData] = useState(data({}));

  function data(data) {
    const safeData = data?.data || {};
    return {
      customerNick: safeData.customerNick || "",
      contactPerson: safeData.contactPerson || "",
      email: safeData.email || "",
      optionalEmail: safeData.optionalEmail || "",
      cell: safeData.cell || "",
      phone: safeData.phone || "",
      company: safeData.company || "",
      country: safeData.country || "",
      state: safeData.state || "",
      city: safeData.city || "",
      address: safeData.address || "",
      zipcode: safeData.zipcode || "",
      website: safeData.website || "",
      Designation: safeData.Designation || "",
    }
  }

  const [errors, setErrors] = useState({});

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Basic validation
  const validate = () => {
    const newErrors = {};
    if (!formData.contactPerson) newErrors.contactPerson = "Required";
    if (!formData.email) newErrors.email = "Required";
    if (!formData.cell) newErrors.cell = "Required";
    if (!formData.cell) newErrors.company = "Required";
    if (!formData.cell) newErrors.country = "Required";
    return newErrors;
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    // Call parent update function or API
    // if (onUpdate) {
    formData._id =auth.data._id;
    //  =auth.data._id;
      dispatch(updateAuthUser(formData,auth.data._id))
      // onUpdate(formData);
    // }
  };

  const handlePasswordChange = (e) => {
  const { name, value } = e.target;
  setPasswordData({ ...passwordData, [name]: value });
};

const validatePasswordForm = () => {
  const newErrors = {};
  if (!passwordData.currentPassword) newErrors.currentPassword = "Current password is required";
  if (!passwordData.newPassword) newErrors.newPassword = "New password is required";
  if (passwordData.newPassword !== passwordData.confirmPassword)
    newErrors.confirmPassword = "Passwords do not match";
  return newErrors;
};

const handlePasswordSubmit = (e) => {
  e.preventDefault();
  const validationErrors = validatePasswordForm();
  if (Object.keys(validationErrors).length > 0) {
    setPasswordErrors(validationErrors);
    return;
  }
  // Dispatch Redux action to update password
  dispatch(updateAuthUserPassword({...passwordData,_id: auth.data._id})); // <- you’ll create this
  setIsPasswordOpen(false);
  setSuccessMsg("Password updated successfully!");
  setTimeout(() => setSuccessMsg(""), 5000);
};


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Dashboard</title>
        </MetaTags>
        <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
          {/* Header */}


          <Container fluid>
             {/* ✅ Success Alert */}
          {successMsg && (
            <Alert color="success" fade={false} transition={{ timeout: 5000 }} className="mb-3" >
              {successMsg}
            </Alert>
          )}
            <Row>
              {/* Main Content */}
              <Col lg={8} md={12}>
                <div className="mb-4">
                  <h2 className="text-dark fw-bold mb-1">Welcome back, {userProfile.customerNick}</h2>
                  <p className="text-muted">Manage your orders and account from your dashboard</p>
                </div>

                {menuItems.map((section, sectionIndex) => (
                  <div key={sectionIndex} className="mb-5">
                    <h5 className="text-dark fw-semibold mb-3 border-bottom pb-2">
                      {section.category}
                    </h5>
                    <Row>
                      {section.items.map((item, index) => (

                        <Col lg={3} md={6} sm={6} xs={12} key={index} className="mb-3">

                          <Card
                            className="h-100 shadow-sm border-0 hover-card"
                            style={{
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              borderRadius: '12px'
                            }}
                            onClick={() => handleMenuClick(item.title)}
                          >
                            <Link to={`/user/${item.link}`}>
                              <CardBody className="text-center p-4">
                                <div
                                  className={`rounded-circle bg-${item.color} d-flex align-items-center justify-content-center mx-auto mb-3`}
                                  style={{ width: '60px', height: '60px', fontSize: '24px' }}
                                >
                                  {item.icon}
                                </div>
                                <h6 className="fw-bold text-dark mb-2">{item.title}</h6>
                                <small className="text-muted">{item.description}</small>
                              </CardBody>
                            </Link>
                          </Card>

                        </Col>

                      ))}
                    </Row>
                  </div>
                ))}
              </Col>

              {/* User Info Sidebar */}
              <Col lg={4} md={12}>
                <Card className="shadow-sm border-0" style={{ borderRadius: '12px' }}>
                  <CardBody className="p-4">
                    <div className="text-center mb-4">
                      <div
                        className="rounded-circle bg-light d-flex align-items-center justify-content-center mx-auto mb-3"
                        style={{ width: '80px', height: '80px' }}
                      >
                        <span className="text-muted" style={{ fontSize: '32px' }}>👤</span>
                      </div>
                      <h5 className="fw-bold text-dark mb-1">{userProfile.customerNick}</h5>
                      <Badge color="secondary" pill>User</Badge>
                    </div>

                    <div className="mb-4">
                      <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                        <span className="text-muted">Email:</span>
                        <span className="fw-semibold">{userProfile.email}</span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                        <span className="text-muted">Phone:</span>
                        <span className="fw-semibold">{userProfile.phone}</span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                        <span className="text-muted">Company:</span>
                        <span className="fw-semibold">{userProfile.company}</span>
                      </div>
                      <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                        <span className="text-muted">Address:</span>
                        <span className="fw-semibold">{userProfile.address}</span>
                      </div>

                      <div className="d-flex justify-content-between align-items-center py-2">
                        <span className="text-muted">Status:</span>
                        <Badge color="success">Active</Badge>
                      </div>

                      <div className="d-flex justify-content-between align-items-center py-2">
                        <Button color="primary" outline size="xlg" className="w-100" onClick={toggle}>
                          Edit Profile
                        </Button>
                      </div>

                      <div className="d-flex justify-content-between align-items-center py-2">
  <Button color="danger" outline size="xlg" className="w-100" onClick={togglePassword}>
    Update Password
  </Button>
</div>


                    </div>

                  
                  </CardBody>
                </Card>

             
              </Col>
            </Row>
            <Row>
              <Offcanvas isOpen={isOpen} direction="end" toggle={toggle} style={{ width: "35%" }}>
                <OffcanvasHeader toggle={toggle}>{userProfile.company}</OffcanvasHeader>
                <OffcanvasBody>
                  <Container>
                    <Row>
                      <Col lg="12">
                        <Card>
                          <CardBody>
                            <Form onSubmit={handleSubmit}>
                              <Row>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label for="contactPerson">Contact Person</Label>
                                    <Input
                                      type="text"
                                      name="contactPerson"
                                      id="contactPerson"
                                      value={formData.contactPerson}
                                      onChange={handleChange}
                                      invalid={!!errors.contactPerson}
                                    />
                                    <FormFeedback>{errors.contactPerson}</FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label for="customerNick">Customer Name</Label>
                                    <Input
                                      type="text"
                                      name="customerNick"
                                      id="customerNick"
                                      value={formData.customerNick}
                                      onChange={handleChange}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label for="email">Email</Label>
                                    <Input
                                      type="email"
                                      name="email"
                                      id="email"
                                      value={formData.email}
                                      onChange={handleChange}
                                      invalid={!!errors.email}
                                    />
                                    <FormFeedback>{errors.email}</FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label for="optionalEmail">Optional Email</Label>
                                    <Input
                                      type="email"
                                      name="optionalEmail"
                                      id="optionalEmail"
                                      value={formData.optionalEmail}
                                      onChange={handleChange}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label for="cell">Mobile No.</Label>
                                    <Input
                                      type="text"
                                      name="cell"
                                      id="cell"
                                      value={formData.cell}
                                      onChange={handleChange}
                                      invalid={!!errors.cell}
                                    />
                                    <FormFeedback>{errors.cell}</FormFeedback>
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label for="phone">Phone</Label>
                                    <Input
                                      type="text"
                                      name="phone"
                                      id="phone"
                                      value={formData.phone}
                                      onChange={handleChange}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label for="company">Company</Label>
                                    <Input
                                      type="text"
                                      name="company"
                                      id="company"
                                      value={formData.company}
                                      onChange={handleChange}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label for="designation">Designation</Label>
                                    <Input
                                      type="text"
                                      name="designation"
                                      id="designation"
                                      value={formData.Designation}
                                      onChange={handleChange}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={4}>
                                  <FormGroup>
                                    <Label for="country">Country</Label>
                                    <Input
                                      type="text"
                                      name="country"
                                      id="country"
                                      value={formData.country}
                                      onChange={handleChange}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={4}>
                                  <FormGroup>
                                    <Label for="state">State</Label>
                                    <Input
                                      type="text"
                                      name="state"
                                      id="state"
                                      value={formData.state}
                                      onChange={handleChange}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={4}>
                                  <FormGroup>
                                    <Label for="city">City</Label>
                                    <Input
                                      type="text"
                                      name="city"
                                      id="city"
                                      value={formData.city}
                                      onChange={handleChange}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>

                              <FormGroup>
                                <Label for="address">Address</Label>
                                <Input
                                  type="textarea"
                                  name="address"
                                  id="address"
                                  value={formData.address}
                                  onChange={handleChange}
                                />
                              </FormGroup>

                              <Row>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label for="zipcode">Zipcode</Label>
                                    <Input
                                      type="text"
                                      name="zipcode"
                                      id="zipcode"
                                      value={formData.zipcode}
                                      onChange={handleChange}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label for="website">Website</Label>
                                    <Input
                                      type="text"
                                      name="website"
                                      id="website"
                                      value={formData.website}
                                      onChange={handleChange}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>


                              <Button color="primary">Update Customer</Button>
                            </Form>

                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Container>
                </OffcanvasBody>
              </Offcanvas>
            </Row>
            <Row>
              <Offcanvas isOpen={isPasswordOpen} direction="end" toggle={togglePassword} style={{ width: "35%" }}>
  <OffcanvasHeader toggle={togglePassword}>Update Password</OffcanvasHeader>
  <OffcanvasBody>
    <Container>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <Form onSubmit={handlePasswordSubmit}>
                <FormGroup>
                  <Label for="currentPassword">Current Password</Label>
                  <Input
                    type="password"
                    name="currentPassword"
                    id="currentPassword"
                    value={passwordData.currentPassword}
                    onChange={handlePasswordChange}
                    invalid={!!passwordErrors.currentPassword}
                  />
                  <FormFeedback>{passwordErrors.currentPassword}</FormFeedback>
                </FormGroup>

                <FormGroup>
                  <Label for="newPassword">New Password</Label>
                  <Input
                    type="password"
                    name="newPassword"
                    id="newPassword"
                    value={passwordData.newPassword}
                    onChange={handlePasswordChange}
                    invalid={!!passwordErrors.newPassword}
                  />
                  <FormFeedback>{passwordErrors.newPassword}</FormFeedback>
                </FormGroup>

                <FormGroup>
                  <Label for="confirmPassword">Confirm New Password</Label>
                  <Input
                    type="password"
                    name="confirmPassword"
                    id="confirmPassword"
                    value={passwordData.confirmPassword}
                    onChange={handlePasswordChange}
                    invalid={!!passwordErrors.confirmPassword}
                  />
                  <FormFeedback>{passwordErrors.confirmPassword}</FormFeedback>
                </FormGroup>

                <Button color="danger">Update Password</Button>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  </OffcanvasBody>
</Offcanvas>

            </Row>
          </Container>

          <style>{`
        .hover-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.1) !important;
        }
        
        .bg-light {
          background-color: #f8f9fa !important;
        }
      `}</style>
        </div>
      </div>
    </React.Fragment>
  )

}

export default UserDashboard;
